// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Banner_banner-container__loading__mYIS\\+ {
  margin: 4rem auto;
  width: 10rem;
  height: 10rem;
}

.Banner_banner-container__banners__eJHrS {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3.5rem;
}

.Banner_banner-container__swiper__Obg-z {
  width: 100%;
}

.Banner_banner-slide__eqpk9 {
  width: 100%;
  height: 50rem;
}

.Banner_banner-slide__img__9592u {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/Banner/Banner.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".banner-container__loading {\n  margin: 4rem auto;\n  width: 10rem;\n  height: 10rem;\n}\n\n.banner-container__banners {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 3.5rem;\n}\n\n.banner-container__swiper {\n  width: 100%;\n}\n\n.banner-slide {\n  width: 100%;\n  height: 50rem;\n}\n\n.banner-slide__img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner-container__loading": `Banner_banner-container__loading__mYIS+`,
	"banner-container__banners": `Banner_banner-container__banners__eJHrS`,
	"banner-container__swiper": `Banner_banner-container__swiper__Obg-z`,
	"banner-slide": `Banner_banner-slide__eqpk9`,
	"banner-slide__img": `Banner_banner-slide__img__9592u`
};
export default ___CSS_LOADER_EXPORT___;
